import { Injectable, Output, EventEmitter, Directive, Input } from "@angular/core"; // updated for visualization layers
import { GenericMapMethodsService } from "./generic-map-methods.service";
import { Globals } from "src/app/shared/globals"; // JIRA ID :-35 Added by Abhilash
import Swal from "sweetalert2";
//Added for Visualization layers
import { GenericLayerService } from "./generic-layer.service";
import * as xml2js from "xml2js";
import { lidarData } from "../interface/lidarData";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { QueryLayersService } from "./query-layers.service";
import { ToastrService } from "ngx-toastr";
import { ILayerSelections } from "../interface/selectedSet";
import { QueryBuilderService } from "./query-builder.service";
import { ILayer } from "../interface/layer";

@Directive()
@Injectable({
  providedIn: "root"
})
export class EventEmittersService {
  public selectedSet: ILayerSelections[];     // array of data about each spaital layer with currently selected assets
  // JIRA ID :-35 Added by Madhuri
  private singleClickOnMapEvt;
  private queriedLayers: any;

  public userLayers: ILayer[] = [];
  public inventoryLayersData: ILayer[] = [];  
  
  public listSelectData;
  private TappedPoint;
  // rename numOfOpenPanels
  // represents how many panels are open on the bottom of the screen for setting height of the cardview.component.html. Appropriate values are 0, 1 and 2.
  public numOfOpenPanels: number = 0;
  public viewChange: boolean = false;
  //Card View Selected Parent and Childs
  public selectedLayerIndex = 0;            // index of active layer in selectedSet
  public selectedFeatureIndex = 0;           // index of active spatial asset in active layer's Data array. This location has red pin on map, and its data displayed in Asset Viewer.
  public selectedChildAssetId: string | null = null;  // populated with AssetID.
  public selectedChildClass: any = null;          // populated with Layer Name, i.e. "Sign" or "Light". Used by AssetViewer
  // Open Card - Grid - Maintance Forms
  public assetTableVisible: boolean = false;
  public assetViewerVisible: boolean = false;
  public taskTableVisible: boolean = false;
  public makeViewerVisible: boolean = false;
  //show lidar represents the view state of the iframe
  public showLidar = false;
  //view lidar data represents weather or not to query for lidar data against GIS services
  public viewLidarData = false;
  public lidarUrl: SafeResourceUrl;
  public assetId: any = null;           //TODO remove, its set but don't believe it is actually used
  public activeAssetChangedBySelect;
  public activeAssetInfo: any;                 // the asset uber array

  // Adding New Assets
  public addNewParent = false;
  public addNewChild = false;
  //Deleteing Asset
  private childDeleted = false;
  // Task related Events
  private taskCreated = false;
  private taskEdited = false;
  private replaceTaskCreated = false;
  private reshapeTaskCreated = false;
  private taskCompleted = false;
  private taskRollback = false;
  public draw;
  public mapclick;

  public closeModel;

  public toggleParent = false;
  //var toggleParent = false;
  // public toggleLight = true;
  // public toggleSign = true;

  public toggleLight = false;
  public toggleSign = false;

  public baseLifeValuesData;
  public modifierValueData;
  // for bug TSDRSAM-1112 by Manikantha
  //public baseLifeConfig;
  //public modifierConfig;
  // DetailedMaintenance
  public openDetailedMaintenance;
  public closedDetailedMaintenance;
  public activeDetailedMaintenance;
  public doubleClickFlagTimeStamp = 0; // JIRA ID :-669 Added by Abhilash
  public singleClickFlagTime = 0; // JIRA ID :-669 Added by Abhilash
  public selectLidar = false;
  public modifierConfig;
  //Added for Visualization layers
  public showVisualizationDetails;
  public visualizationLyrData: any;
  public onlyShowMakeSignFields: boolean = false;
  
  // <!--TSDRSAM-610,TSDRSAM-611 By Mani -->
  public systemManagedFields = ["OBJECTID", "GlobalID"];
  @Output() public emitOpenDetailedMaintenance: EventEmitter<any> = new EventEmitter();
  @Output() public emitClosedDetailedMaintenance: EventEmitter<any> = new EventEmitter();
  @Output() public emitActiveDetailedMaintenance: EventEmitter<any> = new EventEmitter();

  @Output() public emitSelectedFeaturesOnMap: EventEmitter<any> = new EventEmitter();
  @Output() public emitSelectedLayerIndexOnData: EventEmitter<any> = new EventEmitter();
  @Output() public emitSelectedParentIndexOnData: EventEmitter<any> = new EventEmitter();
  @Output() public emitSelectedChildAssetId: EventEmitter<any> = new EventEmitter();
  // Added by Sowjanya Jira Id:-24 on 11/02/2021
  @Output() public eventassessmentnewAssessment: EventEmitter<any> = new EventEmitter();

  @Output() public emitShowGrid: EventEmitter<any> = new EventEmitter();
  @Output() public emitShowCard: EventEmitter<any> = new EventEmitter();
  @Output() public emitMaintenanceView: EventEmitter<any> = new EventEmitter();
  @Output() public emitMakeViewer: EventEmitter<any> = new EventEmitter();

  @Output() public emitTaskCreated: EventEmitter<any> = new EventEmitter();
  @Output() public emitTaskEdited: EventEmitter<any> = new EventEmitter(); //not subscribed anywhere
  @Output() public emitTaskCompleted: EventEmitter<any> = new EventEmitter();

  @Output() public emitactiveAssetChangedBySelect: EventEmitter<any> = new EventEmitter();
  @Output() public emitActiveAssetInfo: EventEmitter<any> = new EventEmitter();

  @Output() public emitreplaceTaskCreated: EventEmitter<any> = new EventEmitter();
  @Output() public emitreshapeTaskCreated: EventEmitter<any> = new EventEmitter();
  @Output() public emitchildDeleted: EventEmitter<any> = new EventEmitter();
  @Output() public emittaskRollback: EventEmitter<any> = new EventEmitter();
  // JIRA ID :-35 Added by Madhuri
  @Output() public emitEnableSingleClick: EventEmitter<any> = new EventEmitter();

  @Output() public emitCloseModel: EventEmitter<any> = new EventEmitter();

  @Output() public emitTaskCreateFormOpened: EventEmitter<any> = new EventEmitter();

  //Added for Visualization layers
  @Output() public emitShowVisualizationDetails: EventEmitter<any> = new EventEmitter();
  @Output() public emitSetVisualizationAssetViewer: EventEmitter<any> = new EventEmitter();
  // lidar data
  @Output() public emitToggleLidar: EventEmitter<lidarData> = new EventEmitter();

  @Output() public emitOnlyMakeSignFields: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public genericMapMethodsService: GenericMapMethodsService,
    public toast: ToastrService,
    public objGlobals: Globals, // JIRA ID :-35 Added by Abhilash
    //Added for Visualization layers,
    private sanitizer: DomSanitizer,
    private genericLayerService: GenericLayerService,
    private queryLayersService: QueryLayersService,
    private qbService: QueryBuilderService,
  ) {

    this.genericMapMethodsService.emitSelectedGraphicsOnMap.subscribe((indexes) => {
      this.setSelectedLayerIndex(indexes.layerIndex, indexes.assetIndex);
      this.setAssetViewer(true);
      this.setSelectedChildAsset(null); // child record can't be selected from the map directly
    });

  }

  public setSelectedFeaturesOnMap(selectedSet: ILayerSelections[], layerIndex: number=0, parentIndex: number=0): void {
    // Respond to new or modified selectedSet by displaying locations on map and 
    // picking one to be 'active' feature (red pin and displayed in asset viewer).
    if (selectedSet && selectedSet.length > 0) {
      this.selectedSet = selectedSet;
      this.selectedLayerIndex = layerIndex;
      this.selectedFeatureIndex = parentIndex;

      if (this.selectedSet.length == 1 && this.selectedSet[0].Data.length == 1) {
        this.setEnableSingleClick(true);
      } else {
        this.setEnableSingleClick(false); // if more than one asset is selected, click-to-select(activate) only works on assets in the selected set
      }
      this.genericMapMethodsService.getOpenTasks(this.selectedSet, this.selectedLayerIndex, this.selectedFeatureIndex);
    } else {
      this.selectedSet = [];
    }
    this.emitSelectedFeaturesOnMap.emit(this.selectedSet);
  }
  
  public setSelectedLayerIndex(layerIndex: number, assetIndex: number = 0): void { // index of the active ILayerSelections in the selectedSet
    // update saved layerIndex, featureIndex and assetId for active feature
    // ...
    // call selectActiveAssetonMap

    // this.selectedSet = 'selected set', organized as array of layers, each with a Data array of selected assets. [0: {Data [], LayerInfo {}}, ...]
    // this.selectedLayerIndexOnData is the index of the layer in the selected set, 
    // this.selectedParentIndexOnData is the index of the asset in that layer's Data array.  'Parent' is a misnomer, these are only spatial assets but may or may not be a parent of a child asset.  'Child' is the index of a child asset in the selected parent asset's Childs array.

    if (this.selectedLayerIndex !== layerIndex){
      this.selectedLayerIndex = layerIndex;
      this.setSelectedChildAsset(null); // reset selected child asset when changing layer
      this.emitSelectedLayerIndexOnData.emit(this.selectedLayerIndex);
    }
    if (this.selectedFeatureIndex !== assetIndex){
      this.selectedFeatureIndex = assetIndex;
      this.emitSelectedParentIndexOnData.emit(this.selectedFeatureIndex);
    }

    if (this.selectedSet?.length > 0) {
      this.assetId = this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex].attributes.AssetID;
    }

    if (layerIndex == 0) {
      this.toggleCardView("Support");  //TODO confirm this assumption is always correct... what if user does not have access to Support layer??
    } else {
      this.toggleCardView("Others");
    }

  //  this.emitSelectedLayerIndexOnData.emit(this.selectedLayerIndexOnData);
    this.emitactiveAssetChangedBySelect.emit(true);
    if (this.selectedSet && this.selectedSet[this.selectedLayerIndex])
      this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }

  public setSelectedFeatureIndex(index: number): void { // index of feature in DATA array
    this.selectedFeatureIndex = index;
    if (this.selectedSet?.length > 0) {
      this.assetId = this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex].attributes.AssetID;
      this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
    }


    
    /////this.selectedChildAssetId = null;  // does this make sense to do here? don't think so



    // this.selectedChildClass = null;
    this.emitSelectedParentIndexOnData.emit(index);
    this.emitactiveAssetChangedBySelect.emit(true);
  }

  public setSelectedChildAsset(assetId: string | null): void {
    // 
    this.selectedChildAssetId = assetId;
    if (assetId?.includes("SIG")){
      this.selectedChildClass = "Sign"
    } else if (assetId?.includes("LGT")) {
      this.selectedChildClass = "Light";
    } else {
      this.selectedChildClass = null;
    }
    this.emitSelectedChildAssetId.emit(assetId);  
    this.assetId = assetId;           // why???
    //this.emitTaskEdited.emit(true);   // why???
  }

  public setAssetViewer(show?: boolean): void {  // AssetViewer
    if (show === true || show === false) {
      this.assetViewerVisible = show;
    } else {
      this.assetViewerVisible = !this.assetViewerVisible;
    }

    if (!this.assetViewerVisible) {
      if (this.draw) {
        this.draw.finishDrawing();
        this.draw.deactivate();
        this.draw.deactivate();   //TODO*** why two?
      }
      if (this.mapclick) {
        this.mapclick.remove();
      }
    }
    this.emitShowCard.emit(this.assetViewerVisible);
  }

  public setAssetTable(show: boolean = !this.assetTableVisible): void {  // AssetView
    if (show !== this.assetTableVisible) {
      if (show && this.taskTableVisible){this.setMaintenanceView();} //1/1/26 don't allow two tables open at once
      this.numOfOpenPanels += show === true ? 1 : -1;
      this.assetTableVisible = show;
      this.emitShowGrid.emit(show);    
    }
  }
  public setMaintenanceView(show: boolean = !this.taskTableVisible): void {
    if(show !== this.taskTableVisible){
      if (show && this.assetTableVisible){this.setAssetTable();} //1/1/26 don't allow two tables open at once
      this.numOfOpenPanels += show === true ? 1 : -1;
      this.taskTableVisible = show;
      this.emitMaintenanceView.emit(show);
    }
  }
  public setMakeViewer(show: boolean = !this.makeViewerVisible): void {
    if(show !== this.makeViewerVisible){
      this.numOfOpenPanels += show === true ? 1 : -1;
      this.makeViewerVisible = show;
      this.emitMakeViewer.emit(show);
    }
  }

  public clearActiveAssetVariables(){   /// this should be doing a lot of emitting to notify other components, right?
    // added 12/28/25
    this.activeAssetInfo = null;
    this.selectedSet = null;
    this.selectedLayerIndex = null;
    this.selectedFeatureIndex = null;
    this.selectedChildAssetId = null;
    this.selectedChildClass = null;
    this.assetId = null;
    this.selectedChildClass = null;
    this.activeAssetChangedBySelect = null;
    this.listSelectData = null;
    this.openDetailedMaintenance = null;
    this.closedDetailedMaintenance = null;
    this.activeDetailedMaintenance = null;
  }

  public emitTaskUpdate(): void {
    this.emitTaskEdited.emit(true);
    this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public emitTaskAdded(value): void {
    this.emitTaskCreated.emit(true);
    if (this.selectedSet && this.selectedSet.length)
      this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }
  public setActiveAssetIsFeature(active: boolean): void {
    this.activeAssetChangedBySelect = active;
    this.emitactiveAssetChangedBySelect.emit(this.activeAssetChangedBySelect);
  }
  public setActiveAsset(feature: any): void {
    this.activeAssetInfo = feature;
    this.emitActiveAssetInfo.emit(this.activeAssetInfo);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public setreplaceTaskCreated(data?: any): void {
    this.replaceTaskCreated = this.activeAssetInfo;
    this.emitreplaceTaskCreated.emit(this.replaceTaskCreated);
    if (this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex].attributes.OBJECTID == this.replaceTaskCreated[0].OBJECTID) {
      if (!this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex]._layer.queryFeatures) {
        this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex]._layer = this.replaceTaskCreated[1].lyrObj;
      }
    }
    this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }

  public setEmitTaskRollback(value): void {
    this.emittaskRollback.emit(value);

    if (this.replaceTaskCreated && this.replaceTaskCreated[0] && this.selectedSet) {
      if (this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex].attributes.OBJECTID == this.replaceTaskCreated[0].OBJECTID) {
        if (!this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex]._layer.queryFeatures) {
          this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex]._layer = this.replaceTaskCreated[1].lyrObj;
        }
      }
    }

    this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public setreshapeTaskCreated(data?: any): void {
    this.reshapeTaskCreated = this.activeAssetInfo;
    this.emitreshapeTaskCreated.emit(this.reshapeTaskCreated);
    if (this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex].attributes.OBJECTID == this.reshapeTaskCreated[0].OBJECTID) {
      if (!this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex]._layer.queryFeatures) {
        this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex]._layer = this.reshapeTaskCreated[1].lyrObj;
      }
    }
    this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public setchildDeleted(data?: any): void {
    this.emitchildDeleted.emit(true);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public settaskCompleted(data?: any): void {
    this.emitTaskCompleted.emit(true);
    this.genericMapMethodsService.selectActiveAssetOnMap(this.selectedSet[this.selectedLayerIndex].Data[this.selectedFeatureIndex], this.activeAssetInfo);
  }
  public closeModelWindow(): void {
    this.emitCloseModel.emit(true);
  }

  toggleCardView(SelectedlayerName, selectedChildRecordsCount?): void {   
    // OBSOLETE?? doesn't currently do anything. 2nd param is never used.
    //            SelectedlayerName is never SupportToSign or SupportToLight

    // if(SelectedlayerName == 'Support'){
    //     this.toggleParent = false;
    //     this.toggleLight = true;
    //     this.toggleSign = true;
    // }
    // else if(SelectedlayerName == 'SupportToSign' || SelectedlayerName == 'Sign'){
    //     this.toggleParent = true;
    //     this.toggleLight = true;
    //     this.toggleSign = false;
    //     this.selectedChildClass = "Sign";
    // }
    // else if(SelectedlayerName == 'SupportToLight' || SelectedlayerName == 'Light'){
    //     this.toggleParent = true;
    //     this.toggleLight = false;
    //     this.toggleSign = true;
    //     this.selectedChildClass = "Light";
    // }
    // else{
    //     this.toggleParent = false;
    //     this.toggleLight = true;
    //     this.toggleSign = true;
    // }

    // if(selectedShildRecordsCount == 0){
    //     this.toggleParent = false;
    // }
    // if(selectedShildRecordsCount > 0){
    //     this.toggleParent = true;
    // }

    if (SelectedlayerName == "Support") {
      this.toggleParent = false;
      this.toggleLight = false;
      this.toggleSign = false;
    } else if (SelectedlayerName == "SupportToSign" || SelectedlayerName == "Sign") {
      this.toggleParent = false;
      this.toggleLight = false;
      this.toggleSign = false;
      this.selectedChildClass = "Sign";
    } else if (SelectedlayerName == "SupportToLight" || SelectedlayerName == "Light") {
      this.toggleParent = false;
      this.toggleLight = false;
      this.toggleSign = false;
      this.selectedChildClass = "Light";
    } else {
      this.toggleParent = false;
      this.toggleLight = false;
      this.toggleSign = false;
    }

    if (selectedChildRecordsCount == 0) {
      this.toggleParent = false;
    }
    if (selectedChildRecordsCount > 0) {
      this.toggleParent = false;
    }
  }

  public disablebutton(): void {
    const buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      (button as HTMLButtonElement).disabled = true;
    }
  }
  public enablebutton(): void {
    const buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      if (button.id != "assetsavebtn") (button as HTMLButtonElement).disabled = false;
    }
  }
  public getCalculatedReplaceYear(layerName, feature): void {
    let replaceYear = null;
    this.baseLifeValuesData.features.filter(
      function (item) {
        // TSDRSAM-671
        if (item.attributes.AssetClass.toUpperCase() == layerName.toUpperCase() && feature.attributes[item.attributes.BLF_Column] == item.attributes.BLF_Domain_Code) {
          replaceYear = new Date(feature.attributes.InstallDate).getFullYear() + item.attributes.BaseLife;

          this.modifierValueData.features.filter(
            function (item) {
              if (item.attributes.AssetClass.toUpperCase() == layerName.toUpperCase() && feature.attributes[item.attributes.BLF_Column] == item.attributes.BLF_Domain_Code) {
                // for bug TSDRSAM-1112 by Manikantha
                if (this.modifierConfig != null) {
                  const columnNameRow = this.modifierConfig.features.filter((config) => {
                    if (config.attributes.AssetClass.toUpperCase() == layerName.toUpperCase() && config.attributes.Modifier_Domain == item.attributes.Modifier_Domain) {
                      return item;
                    }
                  })[0];
                  if (columnNameRow && feature.attributes[columnNameRow.attributes.Modifier_Column] == item.attributes.Modifier_Domain_Code) {
                    replaceYear += item.attributes.Adjust_Years;
                  }
                }
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
    console.log(replaceYear);
    return replaceYear;
  }

  // Added by Madhuri Gupta for JIRA ID:-35 on 08/05/2021
  public setEnableSingleClick(enable: boolean): void {
    // if zero or one asset is selected, allow any asset map location to be clicked to select it.
    if (enable) {
      if (!this.singleClickOnMapEvt) {
        this.addMapSingleClickEvent();
      }
    } else {
      if (this.singleClickOnMapEvt) {
        this.singleClickOnMapEvt.remove();
        this.singleClickOnMapEvt = undefined;
      }
    }
  }

  public addMapSingleClickEvent(): void {
    // Added by Madhuri Gupta for JIRA ID:-35 on 08/05/2021
    // Added for Double click to Zoom to map And Single Click selection
    this.singleClickOnMapEvt = this.genericMapMethodsService.map.on(
      "click",
      function (evt) {
        this.TappedPoint = evt.mapPoint;
        if (this.singleClickFlagTime === 0) {
          this.singleClickFlagTime = evt.timeStamp;
        }
        if (this.singleClickFlagTime) {
          this.doubleClickFlagTimeStamp = evt.timeStamp;
        }
        if (this.doubleClickFlagTimeStamp - this.singleClickFlagTime > 250) {
          this.selectFeaturesByGeometry(evt.mapPoint);
          this.doubleClickFlagTimeStamp = 0;
          this.singleClickFlagTime = 0;
        } else {
          setTimeout(() => {
            if (this.singleClickFlagTime === this.doubleClickFlagTimeStamp && this.singleClickFlagTime != 0 && this.doubleClickFlagTimeStamp != 0) {
              this.selectFeaturesByGeometry(evt.mapPoint);
            }
            this.doubleClickFlagTimeStamp = 0;
            this.singleClickFlagTime = 0;
          }, 400);
        }
      }.bind(this)
    );
  }

  public wfsGetFeatureUrl(lyr: any, geom: any): string {
    const coordinateString = this.coordinateStringForWMSUrl(geom);
    const wfsUrl = this.wms2wfs(lyr);
    if (wfsUrl !== "") {
      return wfsUrl + "?service=WFS&REQUEST=GetFeature&VERSION=1.0.0&typeName=" + lyr.originalLayerTitle + "&" + coordinateString + "&srsName='EPSG:3857'";
    }
    return "";
  }

  public wfsDescribeFeatureTypeUrl(lyr: any): string {
    const wfsUrl = this.wms2wfs(lyr);
    if (wfsUrl !== "") {
      return wfsUrl + "?service=WFS&REQUEST=DescribeFeatureType&VERSION=1.0.0&typeName=" + lyr.originalLayerTitle;
    }
    return "";
  }
  
  private wms2wfs (lyr: any): string {
    const lastSlash = lyr.wmsUrl.lastIndexOf("/");
    if ( lyr.wmsUrl.substring(lastSlash + 1).toLowerCase().includes("wms") ) {
      return lyr.wmsUrl.substring(0, lastSlash + 2) + "f" + lyr.wmsUrl.substring(lastSlash + 3); // wms => wfs
    }
    return "";
  }

  private coordinateStringForWMSUrl(geom: any): string {
    // 8/22/26 extracted to a separate method for generating coordinate string for WMS URL
    let coordinateString: string = "";
    if (geom.x && geom.y) { 
      //point
      const buffer = this.genericMapMethodsService.getBuffer(geom, this.calculateDistanceFromPixels(), "meters");
      if (buffer.rings && buffer.rings[0]) {
          let extent = buffer.getExtent();
          let minX = extent.xmin;
          let minY = extent.ymin;
          let maxX = extent.xmax;
          let maxY = extent.ymax;
          let bBoxString = minX.toString() + "," + minY.toString() + "," + maxX.toString() + "," + maxY.toString();
          coordinateString = "bbox=" + bBoxString + ",'EPSG:3857'";
      }
    } else if (geom.xmin && geom.ymin) { 
      //rectangle
      let bBoxString = geom.xmin.toString() + "," + geom.ymin.toString() + "," + geom.xmax.toString() + "," + geom.ymax.toString();
      coordinateString = "bbox=" + bBoxString + ",'EPSG:3857'";
    } else { 
      //polygon
      let coordPairs: string = "";
      geom.rings[0].forEach((coord) => {
        coordPairs += coord[0].toString() + "," + coord[1].toString() + " ";
      });
      coordinateString = "Filter=<Filter><Intersects><PropertyName>Shape</PropertyName>" +
                        "<gml:Polygon><gml:outerBoundaryIs><gml:LinearRing><gml:coordinates>" + coordPairs + 
                        "</gml:coordinates></gml:LinearRing></gml:outerBoundaryIs></gml:Polygon></Intersects></Filter>";
    }
    return coordinateString;
  }

  public selectFeaturesByGeometry(geom: any): ILayerSelections[] {
    // whouldn't this be a better fit in generic-map-methods service?


    // 8/22/26 - replaces selecteFeatureOnMap, added by Madhuri Gupta for JIRA ID:-35 on 08/05/2021.
    //           consolidates duplicative code from select-tool
    const assetQueries: any[] = [];
    const wfsQueries: any[] = [];
    const visualizationSelectedData: any[] = [];

    this.queriedLayers = [];
    this.listSelectData = [];

    this.genericMapMethodsService.map.enableMapNavigation();
    this.genericMapMethodsService.map.graphicsLayerIds.forEach( (id) => {
        this.genericMapMethodsService.map.getLayer(id).clear();
    });

    if (this.viewLidarData === true){
      const buffer = this.genericMapMethodsService.getBuffer(this.TappedPoint, 100, "meters");
      if (buffer.rings && buffer.rings[0]) {
        let extent = buffer.getExtent();
        let minX = extent.xmin;
        let minY = extent.ymin;
        let maxX = extent.xmax;
        let maxY = extent.ymax;
        this.queryLayersService.getLidarAssets(maxX, minX, maxY, minY).subscribe(res => {
          if(res != null && res.features != null && res.features[0] != null){
            const closestLidarRun = res.features[0].attributes;
            return this.toggleLidarIframe(this.TappedPoint.y, this.TappedPoint.x, closestLidarRun.Custom1,  closestLidarRun.Custom2,  closestLidarRun.Custom3);
          }else{
            this.toast.info("No lidar data available near the selected point.")
          }
        });
      }
    } else {

      const visibleInventoryLayers = this.inventoryLayersData?.filter(lyr => lyr.visible);
      if (visibleInventoryLayers?.length > 0) {
        // build asset queries
        const query = new this.genericMapMethodsService.Query();
        query.geometry = geom;
        if (geom.x) { query.distance = this.calculateDistanceFromPixels(); } // For single click, buffer units in pixels
        visibleInventoryLayers.forEach( (lyr) => {
          assetQueries.push(lyr.lyrObj.selectFeatures(query));      
          this.queriedLayers.push(lyr);
        });
      }

      this.genericMapMethodsService.map.visualizationLayers?.filter(lyr => lyr.visible).forEach((lyr) => {
        //build visualization layer queries 
        wfsQueries.push(this.getSelectedWFSData(this.wfsGetFeatureUrl(lyr, geom), lyr.originalLayerTitle, false));
      });

      // process query results
      this.genericMapMethodsService.all(
          [this.genericMapMethodsService.all(assetQueries), this.genericMapMethodsService.all(wfsQueries)] 
        ).then( ([assetQueriesResults, wfsQueriesResults]) => {

          assetQueriesResults.forEach((selected, i) => {
            if (selected.length > 0) {
              this.listSelectData.push({
                LayerInfo: this.queriedLayers[i],
                Data: selected
              });
            }
          });

          wfsQueriesResults.forEach((selected) => {
            if (selected.length > 0) {
              visualizationSelectedData.push(...this.formatVisualizationData(selected));
            }
          });
          this.listSelectData.push(...visualizationSelectedData);

          //this.emitWFSData(wfsQueriesResults);
          this.setVisualizationAssetViewer(visualizationSelectedData);

          if (geom.x) {
            // only select one asset for single-click select. favor supports.
            let layer = this.listSelectData.filter((row) => row.LayerInfo.name === "Support");
            if (layer.length === 0){
              layer = [this.listSelectData[0]]; // no supports selected, take the first available layer
            }
            layer[0].Data = [layer[0].Data[0]]; // keep only the first feature in the selected layer
            this.listSelectData = [layer[0]];

            // single click select is potentially involved in sign relocate
            this.handleChildRelocate(this.listSelectData);

          }

          if (this.listSelectData.length > 0) {
            if (this.listSelectData.reduce((max, row) => Math.max(max, row.Data.length), 0) == this.genericMapMethodsService.map.smsLayerdata.dynamicMapLayer.maxRecordCount) {
              this.qbService.updateMaxRecordMessage(this.genericMapMethodsService.map.smsLayerdata.dynamicMapLayer.maxRecordCount);
            }
            this.setSelectedFeaturesOnMap(this.listSelectData);
            this.setAssetViewer(true);
          } else {
            this.genericMapMethodsService.map.graphics.clear();
            this.setEnableSingleClick(true);
            this.setAssetViewer(false);           
          }

        }
      );
    }
    return this.listSelectData;
  }

  private calculateDistanceFromPixels() {
    const tolerance = this.objGlobals.toleranceDistance;
    const screenPoint = this.genericMapMethodsService.map.toScreen(this.genericMapMethodsService.map.extent.getCenter());
    const upperLeftScreenPoint = new this.genericMapMethodsService.Point(screenPoint.x - tolerance, screenPoint.y - tolerance);
    const lowerRightScreenPoint = new this.genericMapMethodsService.Point(screenPoint.x + tolerance, screenPoint.y + tolerance);
    const upperLeftMapPoint = this.genericMapMethodsService.map.toMap(upperLeftScreenPoint);
    const lowerRightMapPoint = this.genericMapMethodsService.map.toMap(lowerRightScreenPoint);
    const ext = new this.genericMapMethodsService.Extent(upperLeftMapPoint.x, upperLeftMapPoint.y, lowerRightMapPoint.x, lowerRightMapPoint.y, this.genericMapMethodsService.map.spatialReference);
    console.log(ext.getWidth() / 2);
    return ext.getWidth() / 2;
  }

  public getUpdatedDetailedMaintenance(filterObj: any, requestType: string): void {
    this.genericMapMethodsService.getDetailedMaintenance(filterObj).subscribe((tasks) => {
      if (requestType === "Open") {
        this.openDetailedMaintenance = tasks;
        this.emitOpenDetailedMaintenance.emit(this.openDetailedMaintenance);
      } else if (requestType === "Closed") {
        this.closedDetailedMaintenance = tasks;
        this.emitClosedDetailedMaintenance.emit(this.closedDetailedMaintenance);
      } else if (requestType === "Active") { // no such Maintenance.Status. There is "Inactive" but there is no use case where they need to be got
        this.activeDetailedMaintenance = tasks;
        this.emitActiveDetailedMaintenance.emit(this.activeDetailedMaintenance);
      }
    });
  }

  // Added by Sowjanya Jira Id:-24 on 11/02/2021
  public setEventAssessment(value) {
    this.eventassessmentnewAssessment.emit(value);
  }

  public setUserLayers(userLayers:ILayer[]) {  // added 10/2/26
    this.userLayers = userLayers;
    this.inventoryLayersData = userLayers.filter(l => l.type === "inventory");
  }


  //TSDRSAM 1109
  public selectAssetForTaskRecord(taskAttributes): void {   
    // Select the asset (or parent of the asset) whose task table row or task-attributed map pin was selected. 
    // Only called from make-viewer and my-maintenance

    const taskForChild: boolean = ["Sign", "Light"].includes(taskAttributes.AssetName); 
    const spatialAssetName = taskForChild ? "Support" : taskAttributes.AssetName;
    const query = new this.genericMapMethodsService.Query();
    const queryLayer = this.inventoryLayersData.find((layer: any) => layer.lyrObj.name === spatialAssetName);

    this.assetId = taskForChild ? taskAttributes.ParentID : taskAttributes.AssetID;   // ??
    query.where = "AssetID = '" +  this.assetId  + "'";

    this.selectedChildClass = taskForChild ? taskAttributes.AssetName : null; // ???
    this.selectedChildAssetId = taskForChild ? taskAttributes.AssetID : null;

    const staleSelSet = (this.selectedSet?.length == 1 && this.selectedSet[0].Data?.length == 1 && this.selectedSet[0].Data[0].attributes?.AssetID !== this.assetId) ? true : false;
    if (this.selectedSet && !staleSelSet) {
      const lyrIndex =  this.selectedSet.findIndex(item => item.LayerInfo.name === spatialAssetName);
      const featIndex = this.selectedSet[lyrIndex]?.Data.findIndex(item => item.attributes.AssetID === this.assetId);
      this.setSelectedFeaturesOnMap(this.selectedSet, lyrIndex, featIndex);
      this.setEnableSingleClick(false);
      this.setAssetViewer(this.selectedSet[lyrIndex].Data[featIndex].attributes.Status !== "Inactive");  // inactive assets likely included on make-view history tab. Show on map but don't load into asset viewer
      if (taskForChild){
        this.setSelectedChildAsset(this.selectedChildAssetId); 
      }
    } else {
      // query for asset
      queryLayer.lyrObj.selectFeatures(query).then((result: any) => {
        if (result.length > 0) {
          const rowdataobj = [{
            LayerInfo: queryLayer,
            Data: result
          }];
          this.setSelectedFeaturesOnMap(rowdataobj, 0, 0);
          this.setEnableSingleClick(false);
          this.setAssetViewer(result[0].attributes.Status !== "Inactive");  // inactive assets likely included on make-view history tab. Show on map but don't load into asset viewer
          if (taskForChild){
            this.setSelectedChildAsset(this.selectedChildAssetId); 
          }
        }
      });
    }

  }

  // JTSDRSAM-1099 Manikantha V
  selectParentBeforeRelocate(attributes): void {
    try {
      if (this.singleClickOnMapEvt) {
        this.genericMapMethodsService.map.enableMapNavigation();
        // Clear all graphics before selection
        this.genericMapMethodsService.map.graphicsLayerIds.forEach(
          function (id) {
            this.genericMapMethodsService.map.getLayer(id).clear();
          }.bind(this)
        );
        // Query Data in Selected Geometry
        const query = new this.genericMapMethodsService.Query();
        query.where = "AssetID" + "='" + attributes.ParentID + "'";
        const flRequests = [];
        this.queriedLayers = [];
        this.listSelectData = [];
        this.inventoryLayersData.forEach((lyr, i) => {
          if (lyr.visible) {
            const ftrLayer = lyr.lyrObj;
            flRequests.push(ftrLayer.selectFeatures(query));
            this.queriedLayers.push(lyr);
          }
        });
        if (flRequests.length > 0) {
          this.genericMapMethodsService.all(flRequests).then(
            (results) => {
              results.forEach((element, i) => {
                if (element.length > 0) {
                  element.forEach((data) => {
                    const assetData = [];
                    assetData.push(data);
                    this.listSelectData.push({
                      LayerInfo: this.queriedLayers[i],
                      Data: assetData
                    });
                  });
                }
              });
              const pointData: any[] = [];
              const polylineData: any[] = [];
              const polygonData: any[] = [];
              let rowdataobj: any[] = [];
              this.listSelectData.forEach((row) => {
                const geometryType = row.LayerInfo.lyrObj.geometryType;
                switch (geometryType) {
                  case "esriGeometryPoint":
                    pointData.push(row);
                    break;
                  case "esriGeometryPolyline":
                    polylineData.push(row);
                    break;
                  case "esriGeometryPolygon":
                    polygonData.push(row);
                    break;
                }
              });
              //  combine data based on type
              //rowdataobj = [].concat(pointData, polylineData, polygonData);
              rowdataobj.push(pointData);
              rowdataobj.push(polylineData);
              rowdataobj.push(polygonData);
              if (rowdataobj.length > 0) {
                const selecteddata = [];
                selecteddata.push(rowdataobj[0]);
                if (selecteddata.length > 0) {
                  this.setSelectedFeaturesOnMap(selecteddata);
                }
                if (selecteddata.length > 0) {
                  this.setAssetViewer(true);
                }
              } else {
                this.setAssetViewer(false);
                this.genericMapMethodsService.map.graphics.clear();
                this.genericMapMethodsService.relocateChild = false;
              }
            }
          );
        }
      } else {
        let selected;
        let index;
        let selectedLayer;
        for (let i = 0; i < this.selectedSet.length; i++) {
          selected = this.selectedSet[i].Data.find((d) => d.attributes.AssetID === attributes.ParentID);
          index = this.selectedSet[i].Data.findIndex((d) => d.attributes.AssetID === attributes.ParentID);
          selectedLayer = i;
          if (selected) {
            break;
          }
        }
        if (index >= 0 && selectedLayer >= 0) {
          this.setSelectedLayerIndex(selectedLayer, index);
          this.setAssetViewer(true);
        }
      }
      console.log(attributes);
    } catch (error) {
      console.error(error);
    }
  }

  public createTaskOpened(isOpen: any): void {
    this.emitTaskCreateFormOpened.emit(isOpen);
  }

  public onlyMakeSignFields(TF: boolean): void {
    this.onlyShowMakeSignFields = TF;
    this.emitOnlyMakeSignFields.emit(TF);
  }

  //TSDRSAM-1788
  public setShowVisualizationAssetDetails(layerName, data): void {
    this.emitShowVisualizationDetails.emit({ selectedLayer: layerName, layerData: data });
  }

  public setVisualizationAssetViewer(data): void {
    this.visualizationLyrData = data;
    this.emitSetVisualizationAssetViewer.emit(this.visualizationLyrData);
  }

  public getSelectedWFSData(getFeaturesUrl, layerTitle, isPost, postBody?: any) {
    try {
      return new Promise(
        function (resolve) {
          if (isPost) {
            this.genericLayerService.postWMSLayers(getFeaturesUrl, postBody).subscribe(
              (res: any) => {
                this.processWFSData(res, layerTitle, resolve);
              },
              (err) => {
                console.log(err);
                resolve([]);
              }
            );
          } else {
            this.genericLayerService.getWMSLayers(getFeaturesUrl).subscribe(
              (res: any) => {
                this.processWFSData(res, layerTitle, resolve);
              },
              (err) => {
                console.log(err);
                resolve([]);
              }
            );
          }
        }.bind(this)
      );
    } catch (error) {
      console.error(error);
    }
  }

  processWFSData(res, layerTitle, resolve) {
    // return new Promise(
    //  function (resolve) {
    let wfsData = [];
    let parser = new xml2js.Parser({ trim: true, explicitArray: true });
    if (res) {
      parser.parseString(res, (err, result) => {
        if (result && result.hasOwnProperty("wfs:FeatureCollection") && result["wfs:FeatureCollection"].hasOwnProperty("gml:featureMember")) {
          result["wfs:FeatureCollection"]["gml:featureMember"].forEach((element) => {
            let currentAssetData = [];
            let currentAssetGeometry;
            let currentAssetKey = Object.keys(element)[0];
            if (currentAssetKey) {
              let dataJson = element[currentAssetKey][0];
              let dataKeys = Object.keys(dataJson);
              dataKeys.forEach((key) => {
                if (key != "$") {
                  let fieldName = key.split(":")[1];
                  let fieldValue = dataJson[key][0];
                  //convert gml geometry to esri geometry
                  if (fieldName == "Shape") {
                    let key = Object.keys(fieldValue);
                    if (key.length == 0) {
                      return;
                    }
                    if (key[0] == "gml:MultiLineString") {
                      let geomArray = fieldValue[key[0]][0];
                      for (let array in geomArray) {
                        if (array == "gml:lineStringMember") {
                          let geomObject = geomArray["gml:lineStringMember"][0];
                          let coordinatesArray = geomObject["gml:LineString"][0]["gml:coordinates"];
                          currentAssetGeometry = this.genericMapMethodsService.getGMLPointGeometry(coordinatesArray[0]);
                          break;
                        }
                      }
                    } else if (key[0] == "gml:LineString") {
                      let coordinatesArray = fieldValue[key[0]][0]["gml:coordinates"];
                      currentAssetGeometry = this.genericMapMethodsService.getGMLPointGeometry(coordinatesArray[0]);
                    } else if (key[0] == "gml:MultiPoint") {
                      let geomArray = fieldValue[key[0]][0];
                      for (let array in geomArray) {
                        if (array == "gml:pointMember") {
                          let geomObject = geomArray["gml:pointMember"][0];
                          let coordinatesArray = geomObject["gml:Point"][0]["gml:coordinates"];
                          currentAssetGeometry = this.genericMapMethodsService.getGMLPointGeometry(coordinatesArray[0]);
                          break;
                        }
                      }
                    } else if (key[0] == "gml:Point") {
                      let coordinatesArray = fieldValue[key[0]][0]["gml:coordinates"];
                      currentAssetGeometry = this.genericMapMethodsService.getGMLPointGeometry(coordinatesArray[0]);
                    } else if (key[0] == "gml:MultiPolygon") {
                      let geomArray = fieldValue[key[0]][0];
                      for (let array in geomArray) {
                        if (array == "gml:polygonMember") {
                          let geomObject = geomArray["gml:polygonMember"][0];
                          let coordinatesArray = geomObject["gml:Polygon"][0]["gml:outerBoundaryIs"][0]["gml:LinearRing"][0]["gml:coordinates"];
                          currentAssetGeometry = this.genericMapMethodsService.getGMLPointGeometry(coordinatesArray[0]);
                          break;
                        }
                      }
                    } else if (key[0] == "gml:Polygon") {
                      let coordinatesArray = fieldValue[key[0]][0]["gml:outerBoundaryIs"][0]["gml:LinearRing"][0]["gml:coordinates"];
                      currentAssetGeometry = this.genericMapMethodsService.getGMLPointGeometry(coordinatesArray[0]);
                    }
                  } else {
                    currentAssetData.push({ Label: fieldName, Value: fieldValue });
                  }
                }
              });
            }
            if (currentAssetData.length > 0) {
              let assetData = {};
              assetData["attributes"] = currentAssetData;
              assetData["geometry"] = currentAssetGeometry;
              wfsData.push(assetData);
            }
          });
          //
          let selectedData = [];
          if (wfsData.length > 0) {
            selectedData.push({
              LayerInfo: layerTitle,
              Data: wfsData
            });
          }
          resolve(selectedData);
          console.log(selectedData);
        } else {
          resolve([]);
        }
      });
    } else {
      resolve([]);
    }
    // }.bind(this)

    //   );
  }

  formatVisualizationData(visualizationSelectedData: ILayerSelections[]): ILayerSelections[] {
    // transform visualization data to ILayerSelections format for consistent down-stream code flow
    let layerSelections: ILayerSelections[] = [];
    visualizationSelectedData.forEach((v) => {
      if (v.Data) {
        layerSelections.push({
          LayerInfo: {
            layerId: -999,
            name: v.LayerInfo.toString(),
            alias: v.LayerInfo.toString(),
            aliasSL: v.LayerInfo.toString(),
            accessPrivilege: "Read Only",
            type: "visualization",   // important
            lyrObj: {layerid: -999}
          },
          Data: v.Data
        });
      }
    });
    return layerSelections;
  }

  handleChildRelocate(listSelectData) {
    // on new selection, intended to be a Support but may not be
    if (this.genericMapMethodsService.relocateChild) {
      const support = listSelectData.find((row) => row.LayerInfo.name === "Support");
      if (support) {
        this.genericMapMethodsService.moveToNewParent(support.Data[0].attributes.AssetID, 0, 0);
      } else {
        Swal.fire("Please Select Support");
        this.genericMapMethodsService.relocateChild = false;
      }
    }
  }

  toggleLidarIframe(Latitude: number, Longitude: number, database: string, project:string, run: string) {
    if (!this.showLidar) {
      //lat and long come in as web mercator
      const coords = this.genericMapMethodsService.convertXYToLatLng(Longitude, Latitude);
      this.lidarUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://3m.smartlidar.com/web/VirtualNavigator.html?db=${database}&project=${project}&run=${run}#lat=${coords[1]}&lon=${coords[0]}`);
    }
    this.showLidar = !this.showLidar;
  }

}
